// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS
export const FETCH_KNITTING_DC_DETAILS_REQUEST = 'FETCH_KNITTING_DC_DETAILS_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_FAILURE = 'FETCH_KNITTING_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS
export const FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS
export const FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS
export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS BY ID
export const FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_KNITTING_DC_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GRN_NO_BY_YARN_PO_REQUEST = 'FETCH_GRN_NO_BY_YARN_PO_REQUEST';
export const FETCH_GRN_NO_BY_YARN_PO_SUCCESS = 'FETCH_GRN_NO_BY_YARN_PO_SUCCESS';
export const FETCH_GRN_NO_BY_YARN_PO_FAILURE = 'FETCH_GRN_NO_BY_YARN_PO_FAILURE';

// CREATE PROPERTIES FOR KNITTING_DC DETAILS
export const CREATE_KNITTING_DC_DETAILS_REQUEST = 'CREATE_KNITTING_DC_DETAILS_REQUEST';
export const CREATE_KNITTING_DC_DETAILS_SUCCESS = 'CREATE_KNITTING_DC_DETAILS_SUCCESS';
export const CREATE_KNITTING_DC_DETAILS_FAILURE = 'CREATE_KNITTING_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_KNITTING_DC_DETAILS = 'CREATE_USER_FORM_KNITTING_DC_DETAILS';

// UPDATE PROPERTIES FOR KNITTING_DC DETAILS
export const UPDATE_KNITTING_DC_DETAILS_REQUEST = 'UPDATE_KNITTING_DC_DETAILS_REQUEST';
export const UPDATE_KNITTING_DC_DETAILS_SUCCESS = 'UPDATE_KNITTING_DC_DETAILS_SUCCESS';
export const UPDATE_KNITTING_DC_DETAILS_FAILURE = 'UPDATE_KNITTING_DC_DETAILS_FAILURE';

// FETCH SINGLE KNITTING_DC_DETAILS
export const FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR KNITTING_DC DETAILS
export const DELETE_KNITTING_DC_DETAILS_REQUEST = 'DELETE_KNITTING_DC_DETAILS_REQUEST';
export const DELETE_KNITTING_DC_DETAILS_SUCCESS = 'DELETE_KNITTING_DC_DETAILS_SUCCESS';
export const DELETE_KNITTING_DC_DETAILS_FAILURE = 'DELETE_KNITTING_DC_DETAILS_FAILURE';

export const FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const KNITTING_DC_DETAILS_USERFORM_RESET = 'KNITTING_DC_DETAILS_USERFORM_RESET';

export const KNITTING_FABRIC_DETAILS_GET_REQUEST = 'KNITTING_FABRIC_DETAILS_GET_REQUEST';
export const KNITTING_FABRIC_DETAILS_GET_SUCCESS = 'KNITTING_FABRIC_DETAILS_GET_SUCCESS';
export const KNITTING_FABRIC_DETAILS_GET_FAILURE = 'KNITTING_FABRIC_DETAILS_GET_FAILURE';

export const KNITTING_FABRIC_PROGRAM_ID_GET_REQUEST = 'KNITTING_FABRIC_PROGRAM_ID_GET_REQUEST';
export const KNITTING_FABRIC_PROGRAM_ID_GET_SUCCESS = 'KNITTING_FABRIC_PROGRAM_ID_GET_SUCCESS';
export const KNITTING_FABRIC_PROGRAM_ID_GET_FAILURE = 'KNITTING_FABRIC_PROGRAM_ID_GET_FAILURE';

export const FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_FAILURE';


export const FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_FAILURE';


export const KNITTING_DC_PROGRAM_ID_REQUEST = 'KNITTING_DC_PROGRAM_ID_REQUEST';
export const KNITTING_DC_PROGRAM_ID_SUCCESS = 'KNITTING_DC_PROGRAM_ID_SUCCESS';
export const KNITTING_DC_PROGRAM_ID_FAILURE = 'KNITTING_DC_PROGRAM_ID_FAILURE';

export const SHOW_PREVIOUS_LIST = 'SHOW_PREVIOUS_LIST';


